import { render, staticRenderFns } from "./TpmsWarningEvents.vue?vue&type=template&id=33360887&scoped=true"
import script from "./TpmsWarningEvents.vue?vue&type=script&lang=js"
export * from "./TpmsWarningEvents.vue?vue&type=script&lang=js"
import style0 from "./TpmsWarningEvents.vue?vue&type=style&index=0&id=33360887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33360887",
  null
  
)

export default component.exports